export default {
  methods: {
    formatNumberCompact(value, prefix = '', suffix = '', precision = 1) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '';
      }

      const absValue = Math.abs(value);
      let formattedValue;
      let numberSuffix = '';

      if (absValue >= 1000000) {
        formattedValue = (absValue / 1000000).toFixed(precision);
        numberSuffix = 'm';
      } else if (absValue >= 1000) {
        formattedValue = (absValue / 1000).toFixed(precision);
        numberSuffix = 'k';
      } else {
        formattedValue = absValue.toString();
        if (precision === 0 && formattedValue.endsWith('.0')) {
          formattedValue = formattedValue.substring(0, formattedValue.length - 2);
        }

        if (!numberSuffix) {
          formattedValue = absValue.toFixed(precision);
          if (precision === 0) {
            formattedValue = Math.round(absValue).toString();
          }
        }
      }

      if (precision === 1 && formattedValue.endsWith('.0') && (numberSuffix === 'k' || numberSuffix === 'm')) {
        formattedValue = formattedValue.slice(0, -2);
      }

      return prefix + formattedValue + numberSuffix + suffix;
    },
  },
};
